// =============================================================================
// state
// =============================================================================
const state = {
  postPrice: 510,
  postPriceBorder: 3240,
  tax: 8,
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  post_price: state => state.postPrice,
  post_price_border: state => state.postPriceBorder,
  tax: state => state.tax,
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_data (state, value) {
    state.postPrice = value.post_price;
    state.postPriceBorder = value.post_price_border;
    state.tax = value.tax;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
